import React from "react";
import RestaurantCard from "../RestaurantCard/RestaurantCard";
import FadeUp from "../UI/FadeUp";

const mockRestaurants = [
  {
    id: 1,
    name: "Burger King",
    cuisine: "American • Fast Food • Burgers",
    rating: 4.2,
    reviews: 500,
    time: "25-35 min",
    costForTwo: 350,
    image: "https://images.unsplash.com/photo-1571091718767-18b5b1457add?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    status: "OPEN",
    discount: "20% OFF",
  },
  {
    id: 2,
    name: "Truffles",
    cuisine: "Continental • Desserts • Beverages",
    rating: 4.5,
    reviews: 1200,
    time: "30-40 min",
    costForTwo: 600,
    image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    status: "OPEN",
    discount: null,
  },
  {
    id: 3,
    name: "Meghana Foods",
    cuisine: "Biryani • Andhra • South Indian",
    rating: 4.4,
    reviews: 2000,
    time: "20-30 min",
    costForTwo: 500,
    image: "https://images.unsplash.com/photo-1631515243349-e0cb75fb8d3a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    status: "PRE-ORDER",
    discount: "10% OFF",
  }
];

const FeaturedRestaurants = () => {
  return (
    <section style={{ padding: "80px 24px", background: "var(--bg-light)" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <FadeUp>
          <h2 style={{ fontSize: "32px", marginBottom: "32px", textAlign: "center" }}>Featured Restaurants</h2>
        </FadeUp>
        
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "24px" }}>
          {mockRestaurants.map((restaurant, i) => (
            <FadeUp key={restaurant.id} delay={i * 0.1}>
              <RestaurantCard restaurant={restaurant} />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedRestaurants;
